import { render, staticRenderFns } from "./ProfWidget14.vue?vue&type=template&id=fa567a44&"
import script from "./ProfWidget14.vue?vue&type=script&lang=js&"
export * from "./ProfWidget14.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports